import ParkingAreaPage from "./parkingArea";

export default ParkingAreaPage;